import moment from 'moment';
import Http from '../../../http';
import * as types from './constants';
import { toApi } from './transformer';
import { getTimezone } from '../../../auth/selectors';
import config from '../../../../config';
import { isBrandPromoError } from './utils';

const FETCH_PROMO_CODES_LIMIT = 100;

const fetchAllPromoCodes = (url, { skip = 0, limit = FETCH_PROMO_CODES_LIMIT, ...data }) =>
    Http.get(url, {
      ...data,
      skip,
      limit,
    }).then(({ rows = [] }) => {
      if (rows.length === FETCH_PROMO_CODES_LIMIT) {
        return fetchAllPromoCodes(url, { ...data, skip: skip + FETCH_PROMO_CODES_LIMIT })
            .then(result => rows.concat(result));
      }

      return rows;
    });

const fetchPromoCodes = (url, data = {}) => dispatch =>
  fetchAllPromoCodes(url, data).then(response => dispatch({
    type: types.FETCH_PROMO_CODES,
    payload: response,
  }));

export const fetchOwnerPromoCodes = (ownerId, ownerType, from, to, timezone) => {
  if (from && to && timezone) {
    const fromDateTime = moment.tz(from, timezone).format(config.dateFormatISO);
    const toDateTime = moment.tz(to, timezone).format(config.dateFormatISO);
    return fetchPromoCodes(`/${ownerType}/${ownerId}/promo`, { from: fromDateTime, to: toDateTime });
  }
  return fetchPromoCodes(`/${ownerType}/${ownerId}/promo/`);
};

const fetchPromoCode = url => dispatch =>
  Http.get(url).then(response =>
    dispatch({
      type: types.FETCH_PROMO_CODE,
      payload: response,
    })
  );

export const fetchOwnerPromoCode = (ownerId, ownerType, promoCodeId) => (
  fetchPromoCode(`/${ownerType}/${ownerId}/promo/${promoCodeId}`)
);

const addPromoCode = (url, data) => (dispatch, getState) =>
  Http.post(url, toApi(data, getTimezone(getState()))).then(response =>
    dispatch({
      type: types.ADD_PROMO_CODE,
      payload: response,
    })
  )
  .catch((error) => {
    if (!isBrandPromoError(error)) {
      return Http.handleResponseError(null, error, true);
    }
    throw error;
  });

export const addOwnerPromoCode = (ownerId, ownerType, data) => addPromoCode(`/${ownerType}/${ownerId}/promo`, data);

const updatePromoCode = (url, data) => (dispatch, getState) =>
  Http.put(url, toApi(data, getTimezone(getState()))).then(response =>
    dispatch({
      type: types.UPDATE_PROMO_CODE,
      payload: response,
    })
  )
  .catch((error) => {
    if (!isBrandPromoError(error)) {
      return Http.handleResponseError(null, error, true);
    }
    throw error;
  });

export const updateOwnerPromoCode = (ownerId, ownerType, promoCodeId, data) => (
  updatePromoCode(`/${ownerType}/${ownerId}/promo/${promoCodeId}`, data)
);

const deletePromoCode = (url, promoCodeId) => dispatch =>
  Http.delete(url).then(() =>
    dispatch({
      type: types.DELETE_PROMO_CODE,
      payload: promoCodeId,
    })
  );

export const deleteOwnerPromoCode = (ownerId, ownerType, promoCodeId) => (
  deletePromoCode(`/${ownerType}/${ownerId}/promo/${promoCodeId}`, promoCodeId)
);
